import {
  COVERED_CRAWLERS,
  CRAWLER_CLASSIFICATIONS,
  type CoveredCrawler,
  type CoveredCrawlerCategory,
} from '@prerender/diagnostics-api';

import { crawlerCategoryLabel } from './crawlerCategoryLabels';
import { crawlerLabel } from './crawlerLabels';
import type { MultiSelectGroup, MultiSelectOption } from './MultiSelectFilter';

const CATEGORY_ORDER: readonly CoveredCrawlerCategory[] = ['search', 'ai', 'social'];

const isCovered = (crawler: string): crawler is CoveredCrawler =>
  (COVERED_CRAWLERS as readonly string[]).includes(crawler);

const optionOf = (crawler: string): MultiSelectOption => ({ value: crawler, label: crawlerLabel(crawler) });

const providerGroupsOf = (category: CoveredCrawlerCategory): MultiSelectGroup[] => {
  const inCategory = COVERED_CRAWLERS.filter((crawler) => CRAWLER_CLASSIFICATIONS[crawler].category === category);
  const providers = Array.from(new Set(inCategory.map((crawler) => CRAWLER_CLASSIFICATIONS[crawler].provider)));

  return providers.map((provider) => ({
    label: provider,
    options: inCategory.filter((crawler) => CRAWLER_CLASSIFICATIONS[crawler].provider === provider).map(optionOf),
  }));
};

export const crawlerFilterGroups = (inAddress: readonly string[]): MultiSelectGroup[] => {
  const covered = CATEGORY_ORDER.map((category) => ({
    label: crawlerCategoryLabel(category),
    groups: providerGroupsOf(category),
  }));
  const extras = inAddress.filter((crawler) => !isCovered(crawler));

  return extras.length === 0
    ? covered
    : [...covered, { label: crawlerCategoryLabel('other'), options: extras.map(optionOf) }];
};
